const state = {
  processing: false,
  bulkProcessing: false,
  penalties: [],
};

export default state;
